import Container from "./Container";
import HamburgerMenu from "./HamburgerMenu";
import NotificationsButton from "~/ui/NotificationsButton";
import HelpLink from "~/routes/help/HelpLink";
import { Link } from "@remix-run/react";
import LogoIcon from "./LogoIcon";
import ROUTES from "~/kernel/routing/ROUTES";
import type { NavigationBarProps } from "./NavigationBarProps";
import { SettingsButton } from "./SettingsButton";

export function MobileNavigationBar({ links }: NavigationBarProps) {
  return (
    <div className="bg-white md:invisible md:hidden">
      <Container>
        <nav className="shadow-xs flex w-full flex-row justify-between border-b border-b-slate-100">
          <Link
            to={ROUTES.root.path()}
            className="flex flex-row items-center justify-start"
          >
            <LogoIcon className="w-8" />
          </Link>

          <div className="flex flex-row items-center gap-3">
            <SettingsButton />
            <HelpLink />
            <NotificationsButton />
            <HamburgerMenu links={links} />
          </div>
        </nav>
      </Container>
    </div>
  );
}
